<template>
	<div>
		<div class="main-header">
			<div class="container">
				<h2 class="main-header-text">Email Confirmation</h2>
			</div>
		</div>
		<!-- eo main header -->
		<div class="main-section mgt-40">
			<div class="container">

				<div class="main-card">
					<img src="/static/img/icons/arrow-down-indicator-red.png" alt="" class="top-indicator" />
					<div class="tac">

						<div v-if="isEmailValidated==null" style="margin-top:50px">
							<div class="alert alert-info">
								<strong>Info!</strong> Validating email address, please wait....
							</div>

						</div>
						<div v-else-if="isEmailValidated==false" style="margin-top:50px">
							<div class="alert alert-danger">
								<strong>Warning!</strong> Email validation failed. Please contact our support team from more detail.
							</div>
						</div>
						<div v-else="" style="margin-top:50px">
							<div class="alert alert-success">
								Email validated successfully. Please <router-link :to="'/'">click here</router-link> to login.
							</div>
						</div>
					</div>

				</div>
				<!-- eo main card -->

			</div>
			<!-- eo container -->
		</div>
		<!-- eo main section -->

	</div>
</template>
<script>

import Vue from 'vue'

import authservice from "../../services/authservice";
export default {
  name: "mailvalidation",

  beforeRouteEnter(to, from, next) {
    var promises = [authservice.mailValidate(to.query.userid,to.query.code)];

     Promise.all(promises).then(response => {
          next(p => {
           p.isEmailValidated = response[0].body;
          });
        });
  },
  data(){
    return {
      isEmailValidated: null
    }
  }
}
</script>

